module.exports = __webpack_public_path__ + "img/ico-calendar_month.a333dbd1.svg";